// import React, { useEffect, useState } from "react";
// import { useNavigate } from "react-router-dom";
// import { Api } from "../Api/Api";

// const List = () => {
//   const currentUser = JSON.parse(localStorage.getItem("currentUser"));
//   const role = currentUser?.role; // "admin" | "staff"

//   const [customers, setCustomers] = useState([]);
//   const [payments, setPayments] = useState([]);
//   const [advances, setAdvances] = useState([]);
//   const [types, setTypes] = useState([]);

//   const [type, setType] = useState("all");
//   const [searchTerm, setSearchTerm] = useState(""); // <--- NEW STATE
//   const [mode, setMode] = useState(role === "admin" ? "total" : "weekly");
//   const [selectedDate, setSelectedDate] = useState("");

//   const navigate = useNavigate();

//   useEffect(() => {
//     loadAll();
//   }, []);

//   const loadAll = async () => {
//     const [c, p, a, t] = await Promise.all([
//       fetch(`${Api}customers/list.php`).then((r) => r.json()),
//       fetch(`${Api}payments/list.php`).then((r) => r.json()),
//       fetch(`${Api}advances/list.php`).then((r) => r.json()),
//       fetch(`${Api}customers/types/list.php`).then((r) => r.json()),
//     ]);

//     setCustomers(c.customers || []);
//     setPayments(p.payments || []);
//     setAdvances(a.advances || []);
//     setTypes(t.types || []);
//   };

//   /* ================= DATE HELPERS ================= */
//   const isThisWeek = (date) => {
//     const d = new Date(date);
//     const now = new Date();
//     const weekStart = new Date(now);
//     weekStart.setDate(now.getDate() - now.getDay());
//     weekStart.setHours(0, 0, 0, 0);
//     return d >= weekStart;
//   };

//   const isThisMonth = (date) => {
//     const d = new Date(date);
//     const now = new Date();
//     return (
//       d.getMonth() === now.getMonth() && d.getFullYear() === now.getFullYear()
//     );
//   };

//   const isSameDay = (dateStr, filterStr) => {
//     if (!filterStr) return true;
//     return dateStr === filterStr;
//   };

//   /* ================= FILTER LOGIC ================= */
//   // Combined Filter: Type + Search (Code or Name)
//   const filteredCustomers = customers.filter((c) => {
//     const matchesType = type === "all" || c.type === type;
//     const matchesSearch =
//       c.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
//       c.customer_code.toLowerCase().includes(searchTerm.toLowerCase());

//     return matchesType && matchesSearch;
//   });

//   const customerIds = filteredCustomers.map((c) => Number(c.id));
//   const customerCodeMap = filteredCustomers.reduce((map, c) => {
//     map[c.customer_code] = true;
//     return map;
//   }, {});

//   const filterByMode = (date) => {
//     if (mode === "weekly") return isThisWeek(date);
//     if (mode === "monthly") return isThisMonth(date);
//     if (mode === "custom" && role === "admin")
//       return isSameDay(date, selectedDate);
//     if (mode === "total" && role === "admin") return true;
//     return true;
//   };

//   const isBetweenThisWeek = (dateStr) => {
//   const d = new Date(dateStr);
//   const now = new Date();

//   // Sunday start
//   const weekStart = new Date(now);
//   weekStart.setDate(now.getDate() - now.getDay());
//   weekStart.setHours(0, 0, 0, 0);

//   // Saturday end
//   const weekEnd = new Date(weekStart);
//   weekEnd.setDate(weekStart.getDate() + 6);
//   weekEnd.setHours(23, 59, 59, 999);

//   return d >= weekStart && d <= weekEnd;
// };

//   const filteredPayments = payments.filter((p) => {
//   if (!customerIds.includes(Number(p.customer_id))) return false;

//   if (mode === "weekly") return isBetweenThisWeek(p.payment_date);
//   if (mode === "monthly") return isThisMonth(p.payment_date);
//   if (mode === "custom" && role === "admin")
//     return isSameDay(p.payment_date, selectedDate);
//   if (mode === "total" && role === "admin") return true;

//   return true;
// });

//   const filteredAdvances = advances.filter((a) => {
//     const matchCustomer =
//       customerIds.includes(Number(a.customer_id)) ||
//       customerCodeMap[a.customer_code];
//     if (!matchCustomer) return false;
//     return filterByMode(a.advance_date);
//   });

//   /* ================= CALCULATIONS ================= */
//   const totalInvestment = filteredCustomers.reduce(
//     (sum, c) => sum + Number(c.investment_amount),
//     0,
//   );
//  const totalInterestGenerated = filteredPayments.reduce(
//   (sum, p) => sum + Number(p.paid_amount || 0),
//   0
// );

//   const totalAdvance = filteredAdvances.reduce((sum, a) => {
//     const total = Number(a.advance_amount || 0);
//     const used = Number(a.used_amount || 0);
//     const remaining = Math.max(total - used, 0);
//     return sum + remaining;
//   }, 0);

//   const totalPending = filteredCustomers.reduce((sum, c) => {
//     const weekly = Number(c.weekly_interest_amount || 0);
//     const completedWeeks = getCompletedWeeks(c.given_date);
//     const totalDue = completedWeeks * weekly;
//     const paid = payments
//       .filter((p) => Number(p.customer_id) === Number(c.id))
//       .reduce((s, p) => s + Number(p.paid_amount), 0);
//     return sum + Math.max(totalDue - paid, 0);
//   }, 0);

//   function getCompletedWeeks(givenDate) {
//     const start = new Date(givenDate);
//     const today = new Date();
//     start.setHours(0, 0, 0, 0);
//     today.setHours(0, 0, 0, 0);
//     const diffDays = Math.floor((today - start) / 86400000);
//     return Math.floor(diffDays / 7);
//   }

//   const getCustomerPending = (customer) => {
//     const weekly = Number(customer.weekly_interest_amount || 0);
//     const completedWeeks = getCompletedWeeks(customer.given_date);
//     const totalDue = completedWeeks * weekly;
//     const totalPaid = payments
//       .filter((p) => Number(p.customer_id) === Number(customer.id))
//       .reduce((sum, p) => sum + Number(p.paid_amount || 0), 0);
//     return Math.max(totalDue - totalPaid, 0);
//   };

//   return (
//     <div className="min-h-screen bg-gray-50 p-6">
//       <div className="max-w-7xl mx-auto space-y-6">
//         <h1 className="text-2xl font-extrabold text-gray-800">Customer List</h1>

//         {/* FILTER BAR */}
//         <div className="bg-white p-4 rounded shadow border space-y-4">
//           {/* SEARCH INPUT - TOP ROW */}
//           <div className="w-full">
//             <input
//               type="text"
//               placeholder="Search by name or customer code..."
//               value={searchTerm}
//               onChange={(e) => setSearchTerm(e.target.value)}
//               className="w-full border px-4 py-2.5 rounded-lg font-medium text-sm focus:ring-2 focus:ring-indigo-500 outline-none"
//             />
//           </div>

//           <div className="flex flex-col sm:flex-row gap-4 items-start sm:items-center justify-between">
//             {/* LEFT GROUP: Select and Mode Toggles */}
//             <div className="flex flex-col xs:flex-row gap-4 items-start xs:items-center w-full sm:w-auto">
//               <select
//                 value={type}
//                 onChange={(e) => setType(e.target.value)}
//                 className="border px-3 py-2 rounded font-bold text-sm w-full xs:w-auto bg-white"
//               >
//                 <option value="all">All Types</option>
//                 {types.map((t) => (
//                   <option key={t.id} value={t.type_name}>
//                     {t.type_name}
//                   </option>
//                 ))}
//               </select>

//               <div className="flex bg-gray-100 p-1 rounded w-full xs:w-auto">
//                 {(role === "admin"
//                   ? ["total", "weekly", "monthly"]
//                   : ["weekly", "monthly"]
//                 ).map((m) => (
//                   <button
//                     key={m}
//                     onClick={() => {
//                       setMode(m);
//                       setSelectedDate("");
//                     }}
//                     className={`flex-1 sm:flex-none px-4 py-1.5 rounded text-xs font-bold transition uppercase ${
//                       mode === m
//                         ? "bg-indigo-600 text-white shadow"
//                         : "text-gray-500 hover:text-gray-700"
//                     }`}
//                   >
//                     {m}
//                   </button>
//                 ))}
//               </div>
//             </div>

//             {/* RIGHT GROUP: Admin Date Picker */}
//             {role === "admin" && (
//               <div className="flex flex-wrap items-center gap-2 w-full sm:w-auto pt-2 sm:pt-0 border-t sm:border-t-0 border-gray-100">
//                 <label className="text-xs font-bold text-gray-500 tracking-tighter">
//                   SPECIFIC DATE:
//                 </label>
//                 <div className="flex items-center gap-2 flex-grow sm:flex-grow-0">
//                   <input
//                     type="date"
//                     value={selectedDate}
//                     onChange={(e) => {
//                       setSelectedDate(e.target.value);
//                       setMode("custom");
//                     }}
//                     className="border px-3 py-1.5 rounded font-bold text-sm outline-none focus:ring-2 focus:ring-indigo-500 flex-grow sm:flex-grow-0"
//                   />
//                   {selectedDate && (
//                     <button
//                       onClick={() => {
//                         setSelectedDate("");
//                         setMode("total");
//                       }}
//                       className="text-xs text-red-500 font-bold underline whitespace-nowrap"
//                     >
//                       Clear
//                     </button>
//                   )}
//                 </div>
//               </div>
//             )}
//           </div>
//         </div>

//         {/* SUMMARY CARDS */}
//         <div className="grid grid-cols-1 md:grid-cols-4 lg:grid-cols-5 gap-4">
//           <Card title="TOTAL CUSTOMERS" value={filteredCustomers.length} />
//           {role === "admin" && (
//             <Card
//               title="TOTAL INVESTMENT"
//               value={totalInvestment}
//               color="bg-indigo-50"
//             />
//           )}
//           <Card
//             title="INTEREST GENERATED"
//             value={totalInterestGenerated}
//             color="bg-green-50"
//           />
//           <Card title="PENDING AMOUNT" value={totalPending} color="bg-red-50" />
//           <Card
//             title="TOTAL ADVANCE"
//             value={totalAdvance}
//             color="bg-amber-50"
//           />
//         </div>

//         {/* TABLE */}
//         <div className="bg-white rounded shadow border overflow-x-auto">
//           <table className="w-full text-sm border-collapse">
//             <thead className="bg-gray-100 uppercase text-[11px] text-gray-600">
//               <tr>
//                 <th className="border px-4 py-3 text-left">#</th>
//                 <th className="border px-4 py-3 text-left">Code</th>
//                 <th className="border px-4 py-3 text-left">Name</th>
//                 <th className="border px-4 py-3 text-left">Type</th>
//                 <th className="border px-4 py-3 text-right">Pending</th>
//                 <th className="border px-4 py-3 text-center">Action</th>
//               </tr>
//             </thead>
//             <tbody>
//               {filteredCustomers.map((c, i) => (
//                 <tr key={c.id} className="hover:bg-gray-50 transition">
//                   <td className="border px-4 py-2 text-gray-400">{i + 1}</td>
//                   <td className="border px-4 py-2 font-bold text-indigo-900">
//                     {c.customer_code}
//                   </td>
//                   <td className="border px-4 py-2 font-bold">{c.name}</td>
//                   <td className="border px-4 py-2 text-gray-600">{c.type}</td>
//                   <td className="border px-4 py-2 text-right font-bold text-red-600">
//                     ₹{getCustomerPending(c).toLocaleString("en-IN")}
//                   </td>
//                   <td className="border px-4 py-2 text-center">
//                     <button
//                       onClick={() =>
//                         navigate(
//                           role === "admin"
//                             ? `/admin/customers/${c.id}`
//                             : `/staff/customers/${c.id}`,
//                         )
//                       }
//                       className="px-4 py-1 bg-indigo-600 text-white rounded text-xs font-bold hover:bg-indigo-700"
//                     >
//                       View
//                     </button>
//                   </td>
//                 </tr>
//               ))}
//               {filteredCustomers.length === 0 && (
//                 <tr>
//                   <td colSpan="6" className="text-center py-10 text-gray-400">
//                     No customers found matching your search.
//                   </td>
//                 </tr>
//               )}
//             </tbody>
//           </table>
//         </div>
//       </div>
//     </div>
//   );
// };

// const Card = ({ title, value, color = "bg-white" }) => (
//   <div className={`p-4 rounded-xl shadow border ${color}`}>
//     <p className="text-[10px] font-bold text-gray-500 uppercase tracking-wider">
//       {title}
//     </p>
//     <p className="text-2xl font-black mt-1">
//       {title === "TOTAL CUSTOMERS"
//         ? value
//         : `₹${Number(value).toLocaleString("en-IN")}`}
//     </p>
//   </div>
// );

// export default List;

// import React, { useEffect, useState } from "react";
// import { useNavigate } from "react-router-dom";
// import { Api } from "../Api/Api";

// const List = () => {
//   const currentUser = JSON.parse(localStorage.getItem("currentUser"));
//   const role = currentUser?.role;

//   const [customers, setCustomers] = useState([]);
//   const [payments, setPayments] = useState([]);
//   const [advances, setAdvances] = useState([]);
//   const [types, setTypes] = useState([]);

//   const [type, setType] = useState("all");
//   const [searchTerm, setSearchTerm] = useState("");
//   // Modes: total, today, weekly, monthly, range
//   const [mode, setMode] = useState(role === "admin" ? "total" : "weekly");

//   // DATE STATES
//   const [dateRange, setDateRange] = useState({
//     start: new Date().toISOString().split("T")[0],
//     end: new Date().toISOString().split("T")[0],
//   });

//   const navigate = useNavigate();

//   useEffect(() => {
//     loadAll();
//   }, []);

//   const loadAll = async () => {
//     const [c, p, a, t] = await Promise.all([
//       fetch(`${Api}customers/list.php`).then((r) => r.json()),
//       fetch(`${Api}payments/list.php`).then((r) => r.json()),
//       fetch(`${Api}advances/list.php`).then((r) => r.json()),
//       fetch(`${Api}customers/types/list.php`).then((r) => r.json()),
//     ]);

//     setCustomers(c.customers || []);
//     setPayments(p.payments || []);
//     setAdvances(a.advances || []);
//     setTypes(t.types || []);
//   };

//   /* ================= DATE HELPERS ================= */
//   const getCompletedWeeks = (givenDate) => {
//     const start = new Date(givenDate);
//     const today = new Date();
//     start.setHours(0, 0, 0, 0);
//     today.setHours(0, 0, 0, 0);
//     const diffDays = Math.floor((today - start) / 86400000);
//     return Math.floor(diffDays / 7);
//   };

//   const checkDateMatch = (dateStr) => {
//     const d = new Date(dateStr);
//     d.setHours(0, 0, 0, 0);
//     const now = new Date();

//     if (mode === "total") return true;

//     if (mode === "today") {
//       const today = new Date();
//       today.setHours(0, 0, 0, 0);
//       return d.getTime() === today.getTime();
//     }

//     if (mode === "weekly") {
//       const weekStart = new Date(now);
//       weekStart.setDate(now.getDate() - now.getDay());
//       weekStart.setHours(0, 0, 0, 0);
//       const weekEnd = new Date(weekStart);
//       weekEnd.setDate(weekStart.getDate() + 6);
//       weekEnd.setHours(23, 59, 59, 999);
//       return d >= weekStart && d <= weekEnd;
//     }

//     if (mode === "monthly") {
//       return (
//         d.getMonth() === now.getMonth() && d.getFullYear() === now.getFullYear()
//       );
//     }

//     if (mode === "range") {
//       const start = new Date(dateRange.start);
//       start.setHours(0, 0, 0, 0);
//       const end = new Date(dateRange.end);
//       end.setHours(23, 59, 59, 999);
//       return d >= start && d <= end;
//     }

//     return true;
//   };

//   /* ================= FILTER LOGIC ================= */
//   const filteredCustomers = customers.filter((c) => {
//     const matchesType = type === "all" || c.type === type;
//     const matchesSearch =
//       c.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
//       c.customer_code.toLowerCase().includes(searchTerm.toLowerCase());
//     return matchesType && matchesSearch;
//   });

//   const customerIds = filteredCustomers.map((c) => Number(c.id));

//   const filteredPayments = payments.filter((p) => {
//     if (!customerIds.includes(Number(p.customer_id))) return false;
//     return checkDateMatch(p.payment_date);
//   });

//   const filteredAdvances = advances.filter((a) => {
//     if (!customerIds.includes(Number(a.customer_id))) return false;
//     return checkDateMatch(a.advance_date);
//   });

//   /* ================= CALCULATIONS ================= */
//   const totalInvestment = filteredCustomers.reduce(
//     (sum, c) => sum + Number(c.investment_amount),
//     0,
//   );
//   const totalInterestGenerated = filteredPayments.reduce(
//     (sum, p) => sum + Number(p.paid_amount || 0),
//     0,
//   );
//   const totalAdvance = filteredAdvances.reduce(
//     (sum, a) =>
//       sum + (Number(a.advance_amount || 0) - Number(a.used_amount || 0)),
//     0,
//   );

//   const getCustomerPending = (customer) => {
//     const weekly = Number(customer.weekly_interest_amount || 0);
//     const completedWeeks = getCompletedWeeks(customer.given_date);
//     const totalDue = completedWeeks * weekly;
//     const totalPaid = payments
//       .filter((p) => Number(p.customer_id) === Number(customer.id))
//       .reduce((sum, p) => sum + Number(p.paid_amount || 0), 0);
//     return Math.max(totalDue - totalPaid, 0);
//   };

//   const totalPending = filteredCustomers.reduce(
//     (sum, c) => sum + getCustomerPending(c),
//     0,
//   );

//   return (
//     <div className="min-h-screen bg-gray-50 p-6">
//       <div className="max-w-7xl mx-auto space-y-6">
//         <h1 className="text-2xl font-extrabold text-gray-800 tracking-tight">
//           Customer Financial Ledger
//         </h1>

//         {/* FILTER BAR */}
//         <div className="bg-white p-5 rounded-xl shadow-sm border border-gray-200 space-y-5">
//           {/* SEARCH */}
//           <input
//             type="text"
//             placeholder="Search by name or code..."
//             value={searchTerm}
//             onChange={(e) => setSearchTerm(e.target.value)}
//             className="w-full border-gray-200 border px-4 py-3 rounded-xl font-medium text-sm focus:ring-2 focus:ring-indigo-500 outline-none transition-all"
//           />

//           <div className="flex flex-wrap gap-4 items-center justify-between">
//             {/* TYPE & MODE */}
//             <div className="flex flex-wrap gap-3 items-center">
//               <select
//                 value={type}
//                 onChange={(e) => setType(e.target.value)}
//                 className="border px-4 py-2 rounded-lg font-bold text-xs bg-gray-50 uppercase outline-none"
//               >
//                 <option value="all">All Types</option>
//                 {types.map((t) => (
//                   <option key={t.id} value={t.type_name}>
//                     {t.type_name}
//                   </option>
//                 ))}
//               </select>

//               <div className="flex bg-gray-100 p-1 rounded-lg">
//                 {(role === "admin"
//                   ? ["total", "today", "weekly", "monthly", "range"]
//                   : ["today", "weekly", "monthly"]
//                 ).map((m) => (
//                   <button
//                     key={m}
//                     onClick={() => setMode(m)}
//                     className={`px-4 py-1.5 rounded-md text-[10px] font-black transition uppercase ${
//                       mode === m
//                         ? "bg-indigo-600 text-white shadow-sm"
//                         : "text-gray-500 hover:bg-gray-200"
//                     }`}
//                   >
//                     {m}
//                   </button>
//                 ))}
//               </div>
//             </div>

//             {/* DATE RANGE PICKER */}
//             {mode === "range" && (
//               <div className="flex items-center gap-2 bg-indigo-50 p-2 rounded-lg border border-indigo-100 animate-in fade-in duration-300">
//                 <span className="text-[10px] font-black text-indigo-400 uppercase px-2">
//                   Range:
//                 </span>
//                 <input
//                   type="date"
//                   value={dateRange.start}
//                   onChange={(e) =>
//                     setDateRange({ ...dateRange, start: e.target.value })
//                   }
//                   className="border-none bg-transparent font-bold text-xs outline-none"
//                 />
//                 <span className="text-indigo-300">to</span>
//                 <input
//                   type="date"
//                   value={dateRange.end}
//                   onChange={(e) =>
//                     setDateRange({ ...dateRange, end: e.target.value })
//                   }
//                   className="border-none bg-transparent font-bold text-xs outline-none"
//                 />
//               </div>
//             )}
//           </div>
//         </div>

//         {/* SUMMARY CARDS */}
//         {/* <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-4"> */}
//         <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
//           <Card title="CUSTOMERS" value={filteredCustomers.length} isCount />
//           {role === "admin" && (
//             <Card
//               title="INVESTMENT"
//               value={totalInvestment}
//               color="bg-indigo-50"
//             />
//           )}
//           <Card
//             title="INTEREST"
//             value={totalInterestGenerated}
//             color="bg-green-50"
//           />
//           <Card title="PENDING" value={totalPending} color="bg-red-50" />
//           <Card title="ADVANCE" value={totalAdvance} color="bg-amber-50" />
//         </div>

//         {/* TABLE */}
//         <div className="bg-white rounded-xl shadow-sm border border-gray-200 overflow-hidden">
//           <table className="w-full text-sm">
//             <thead className="bg-gray-50 uppercase text-[10px] font-black text-gray-500 tracking-widest border-b">
//               <tr>
//                 <th className="px-6 py-4 text-left">#</th>
//                 <th className="px-6 py-4 text-left">Code</th>
//                 <th className="px-6 py-4 text-left">Name</th>
//                 <th className="px-6 py-4 text-left">Type</th>
//                 <th className="px-6 py-4 text-right">Pending</th>
//                 <th className="px-6 py-4 text-center">Action</th>
//               </tr>
//             </thead>
//             <tbody className="divide-y divide-gray-100">
//               {filteredCustomers.map((c, i) => (
//                 <tr
//                   key={c.id}
//                   className="hover:bg-indigo-50/30 transition-colors group"
//                 >
//                   <td className="px-6 py-3 text-gray-400">{i + 1}</td>
//                   <td className="px-6 py-3 font-black text-indigo-600">
//                     {c.customer_code}
//                   </td>
//                   <td className="px-6 py-3 font-bold text-gray-800">
//                     {c.name}
//                   </td>
//                   <td className="px-6 py-3 text-xs font-medium text-gray-500">
//                     {c.type}
//                   </td>
//                   <td className="px-6 py-3 text-right font-black text-red-600">
//                     ₹{getCustomerPending(c).toLocaleString("en-IN")}
//                   </td>
//                   <td className="px-6 py-3 text-center">
//                     <button
//                       onClick={() =>
//                         navigate(
//                           role === "admin"
//                             ? `/admin/customers/${c.id}`
//                             : `/staff/customers/${c.id}`,
//                         )
//                       }
//                       className="px-5 py-1.5 bg-indigo-600 text-white rounded-lg text-[10px] font-black hover:bg-indigo-700 shadow-sm"
//                     >
//                       VIEW
//                     </button>
//                   </td>
//                 </tr>
//               ))}
//             </tbody>
//           </table>
//         </div>
//       </div>
//     </div>
//   );
// };

// const Card = ({ title, value, color = "bg-white", isCount = false }) => (
//   <div className={`p-5 rounded-2xl border border-gray-100 shadow-sm ${color}`}>
//     <p className="text-[10px] font-black text-gray-400 uppercase tracking-widest">
//       {title}
//     </p>
//     <p className="text-2xl font-black mt-2 text-gray-900">
//       {isCount ? value : `₹${Number(value).toLocaleString("en-IN")}`}
//     </p>
//   </div>
// );

// export default List;



import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Api } from "../Api/Api";

const List = () => {
  const currentUser = JSON.parse(localStorage.getItem("currentUser"));
  const role = currentUser?.role;

  const [customers, setCustomers] = useState([]);
  const [payments, setPayments] = useState([]);
  const [advances, setAdvances] = useState([]);
  const [types, setTypes] = useState([]);

  const [type, setType] = useState("all");
  const [searchTerm, setSearchTerm] = useState("");
  const [mode, setMode] = useState(role === "admin" ? "total" : "weekly");

  const [dateRange, setDateRange] = useState({
    start: new Date().toISOString().split("T")[0],
    end: new Date().toISOString().split("T")[0],
  });

  const navigate = useNavigate();

  useEffect(() => {
    loadAll();
  }, []);

  const loadAll = async () => {
    try {
      const [c, p, a, t] = await Promise.all([
        fetch(`${Api}customers/list.php`).then((r) => r.json()),
        fetch(`${Api}payments/list.php`).then((r) => r.json()),
        fetch(`${Api}advances/list.php`).then((r) => r.json()),
        fetch(`${Api}customers/types/list.php`).then((r) => r.json()),
      ]);

      setCustomers(c.customers || []);
      setPayments(p.payments || []);
      setAdvances(a.advances || []);
      setTypes(t.types || []);
    } catch (err) {
      console.error("Data fetch failed", err);
    }
  };

  /* ================= DATE HELPERS ================= */
  const getCompletedWeeks = (givenDate) => {
    const start = new Date(givenDate);
    const today = new Date();
    start.setHours(0, 0, 0, 0);
    today.setHours(0, 0, 0, 0);
    const diffDays = Math.floor((today - start) / 86400000);
    return Math.max(0, Math.floor(diffDays / 7));
  };

  const checkDateMatch = (dateStr) => {
    const d = new Date(dateStr);
    d.setHours(0, 0, 0, 0);
    const now = new Date();

    if (mode === "total") return true;
    if (mode === "today") {
      const today = new Date();
      today.setHours(0, 0, 0, 0);
      return d.getTime() === today.getTime();
    }
    if (mode === "weekly") {
      const weekStart = new Date(now);
      weekStart.setDate(now.getDate() - now.getDay());
      weekStart.setHours(0, 0, 0, 0);
      const weekEnd = new Date(weekStart);
      weekEnd.setDate(weekStart.getDate() + 6);
      weekEnd.setHours(23, 59, 59, 999);
      return d >= weekStart && d <= weekEnd;
    }
    if (mode === "monthly") {
      return d.getMonth() === now.getMonth() && d.getFullYear() === now.getFullYear();
    }
    if (mode === "range") {
      const start = new Date(dateRange.start);
      start.setHours(0, 0, 0, 0);
      const end = new Date(dateRange.end);
      end.setHours(23, 59, 59, 999);
      return d >= start && d <= end;
    }
    return true;
  };

  /* ================= FILTER LOGIC ================= */


  const filteredCustomers = customers.filter((c) => {
    // ❌ Hide closed customers
    const notClosed =
      c.status?.toLowerCase() !== "close" &&
      c.status?.toLowerCase() !== "closed";

    const matchesType = type === "all" || c.type === type;

    // const matchesSearch =
    //   c.name?.toLowerCase().includes(searchTerm.toLowerCase()) ||
    //   c.customer_code?.toLowerCase().includes(searchTerm.toLowerCase());

    const search = searchTerm.toLowerCase();

    const matchesSearch =
      (c.name || "").toLowerCase().includes(search) ||
      (c.customer_code || "").toLowerCase().includes(search);

    return notClosed && matchesType && matchesSearch;
  });


  const customerIds = filteredCustomers.map((c) => Number(c.id));

  const filteredPayments = payments.filter((p) => {
    if (!customerIds.includes(Number(p.customer_id))) return false;
    return checkDateMatch(p.payment_date);
  });

  const filteredAdvances = advances.filter((a) => {
    if (!customerIds.includes(Number(a.customer_id))) return false;
    return checkDateMatch(a.advance_date);
  });

  /* ================= CALCULATIONS ================= */
  const totalInvestment = filteredCustomers.reduce((sum, c) => sum + Number(c.investment_amount), 0);
  const totalInterestGenerated = filteredPayments.reduce((sum, p) => sum + Number(p.paid_amount || 0), 0);
  const totalAdvance = filteredAdvances.reduce(
    (sum, a) => sum + (Number(a.advance_amount || 0) - Number(a.used_amount || 0)),
    0
  );


    const getDueForMode = (customer) => {
      const weekly = Number(customer.weekly_interest_amount || 0);
      const givenDate = new Date(customer.given_date);
      const now = new Date();

      let due = 0;

      if (mode === "today") {
        const diffDays = Math.floor((now - givenDate) / 86400000);
        if (diffDays >= 0 && diffDays % 7 === 0) {
          due += weekly;
        }
      }

      if (mode === "weekly") {
        const weekStart = new Date(now);
        weekStart.setDate(now.getDate() - now.getDay());
        weekStart.setHours(0, 0, 0, 0);

        const weekEnd = new Date(weekStart);
        weekEnd.setDate(weekStart.getDate() + 6);

        let tempDate = new Date(givenDate);

        while (tempDate <= weekEnd) {
          if (tempDate >= weekStart) {
            due += weekly;
          }
          tempDate.setDate(tempDate.getDate() + 7);
        }
      }

      if (mode === "monthly") {
        let tempDate = new Date(givenDate);

        while (tempDate <= now) {
          if (
            tempDate.getMonth() === now.getMonth() &&
            tempDate.getFullYear() === now.getFullYear()
          ) {
            due += weekly;
          }
          tempDate.setDate(tempDate.getDate() + 7);
        }
      }

      if (mode === "total") {
        const completedWeeks = getCompletedWeeks(customer.given_date);
        due = completedWeeks * weekly;
      }

      return due;
    };

  const getCustomerPending = (customer) => {
    const weekly = Number(customer.weekly_interest_amount || 0);
    const completedWeeks = getCompletedWeeks(customer.given_date);
    const totalDue = completedWeeks * weekly;
    // const totalPaid = payments
    //   .filter((p) => Number(p.customer_id) === Number(customer.id))
   const totalPaid = payments
     .filter((p) => Number(p.customer_id) === Number(customer.id))
     .reduce((sum, p) => sum + Number(p.paid_amount || 0), 0);
    return Math.max(totalDue - totalPaid, 0);
  };

  const totalPending = filteredCustomers.reduce((sum, c) => sum + getCustomerPending(c), 0);

  const totalIncoming = filteredCustomers.reduce((sum, c) => {
    const due = getDueForMode(c);

    const paidInMode = filteredPayments
      .filter((p) => Number(p.customer_id) === Number(c.id))
      .reduce((s, p) => s + Number(p.paid_amount || 0), 0);

    return sum + Math.max(due - paidInMode, 0);
  }, 0);



  return (
    <div className="min-h-screen bg-gray-50 p-4 md:p-6">
      <div className="max-w-7xl mx-auto space-y-4 md:space-y-6">
        <h1 className="text-xl md:text-2xl font-extrabold text-gray-800 tracking-tight">
          Customer Financial Ledger
        </h1>

        {/* FILTER BAR - Responsive Flex */}
        <div className="bg-white p-3 sm:p-5 rounded-xl shadow-sm border border-gray-200 space-y-4 w-full overflow-hidden">
          {/* Search Bar */}
          <div className="w-full">
            <input
              type="text"
              placeholder="Search by name or code..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              className="w-full border-gray-200 border px-4 py-3 rounded-xl font-medium text-sm focus:ring-2 focus:ring-indigo-500 outline-none transition-all"
            />
          </div>

          <div className="flex flex-col gap-4">
            {/* Top Row: Select and Mode Switcher */}
            <div className="flex flex-col md:flex-row gap-3 items-stretch md:items-center justify-between">
              {/* Dropdown - Full width on mobile */}
              <select
                value={type}
                onChange={(e) => setType(e.target.value)}
                className="w-full md:w-auto border px-4 py-2.5 rounded-lg font-bold text-xs bg-gray-50 uppercase outline-none focus:border-indigo-500 cursor-pointer"
              >
                <option value="all">All Types</option>
                {types.map((t) => (
                  <option key={t.id} value={t.type_name}>
                    {t.type_name}
                  </option>
                ))}
              </select>

              {/* Mode Switcher - Scrollable horizontally on mobile */}
              <div className="flex bg-gray-100 p-1 rounded-lg overflow-x-auto no-scrollbar touch-pan-x">
                <div className="flex flex-nowrap gap-1 w-full">
                  {(role === "admin"
                    ? ["total", "today", "weekly", "monthly", "range"]
                    : ["today", "weekly", "monthly"]
                  ).map((m) => (
                    <button
                      key={m}
                      onClick={() => setMode(m)}
                      className={`px-3 py-2 rounded-md text-[10px] font-black transition uppercase whitespace-nowrap flex-1 text-center ${
                        mode === m
                          ? "bg-indigo-600 text-white shadow-sm"
                          : "text-gray-500 hover:bg-gray-200"
                      }`}
                    >
                      {m}
                    </button>
                  ))}
                </div>
              </div>
            </div>

            {/* Date Range Row - Stacks on mobile */}
            {mode === "range" && (
              <div className="flex flex-col sm:flex-row items-center gap-2 bg-indigo-50 p-2 rounded-lg border border-indigo-100 w-full">
                <input
                  type="date"
                  value={dateRange.start}
                  onChange={(e) =>
                    setDateRange({ ...dateRange, start: e.target.value })
                  }
                  className="bg-white sm:bg-transparent border border-gray-200 sm:border-none rounded-md p-2 w-full font-bold text-xs outline-none"
                />

                <span className="text-indigo-400 text-[10px] font-bold uppercase">
                  to
                </span>

                <input
                  type="date"
                  value={dateRange.end}
                  onChange={(e) =>
                    setDateRange({ ...dateRange, end: e.target.value })
                  }
                  className="bg-white sm:bg-transparent border border-gray-200 sm:border-none rounded-md p-2 w-full font-bold text-xs outline-none"
                />
              </div>
            )}
          </div>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-3 md:gap-4">
          <Card
            title="CUSTOMERS"
            value={filteredCustomers.length}
            isCount
            color="bg-gray-900"
          />

          {role === "admin" && (
            <Card
              title="INVESTMENT"
              value={totalInvestment}
              color="bg-indigo-900"
            />
          )}

          <Card
            title="INTEREST"
            value={totalInterestGenerated}
            color="bg-green-900"
          />
          {/* <Card title="INCOMING" value={totalIncoming} color="bg-blue-800" /> */}
          <Card title="PENDING" value={totalPending} color="bg-red-900" />
          <Card title="ADVANCE" value={totalAdvance} color="bg-amber-900" />
        </div>

        {/* TABLE CONTAINER - This makes it scrollable on mobile */}
        <div className="bg-white rounded-xl shadow-sm border border-gray-200 overflow-hidden">
          <div className="overflow-x-auto w-full">
            <table className="w-full text-sm min-w-[600px]">
              <thead className="bg-gray-50 uppercase text-[10px] font-black text-gray-500 tracking-widest border-b">
                <tr>
                  <th className="px-6 py-4 text-left">#</th>
                  <th className="px-6 py-4 text-left">Code</th>
                  <th className="px-6 py-4 text-left">Name</th>
                  <th className="px-6 py-4 text-left">Type</th>
                  <th className="px-6 py-4 text-right">Pending</th>
                  <th className="px-6 py-4 text-center">Action</th>
                </tr>
              </thead>
              <tbody className="divide-y divide-gray-100">
                {filteredCustomers.map((c, i) => (
                  <tr
                    key={c.id}
                    className="hover:bg-indigo-50/30 transition-colors group"
                  >
                    <td className="px-6 py-3 text-gray-400 whitespace-nowrap">
                      {i + 1}
                    </td>
                    <td className="px-6 py-3 font-black text-indigo-600 whitespace-nowrap">
                      {c.customer_code}
                    </td>
                    <td className="px-6 py-3 font-bold text-gray-800 whitespace-nowrap">
                      {c.name}
                    </td>
                    <td className="px-6 py-3 text-xs font-medium text-gray-500 whitespace-nowrap">
                      {c.type}
                    </td>
                    <td className="px-6 py-3 text-right font-black text-red-600 whitespace-nowrap">
                      ₹{getCustomerPending(c).toLocaleString("en-IN")}
                    </td>
                    <td className="px-6 py-3 text-center whitespace-nowrap">
                      <button
                        onClick={() =>
                          navigate(
                            role === "admin"
                              ? `/admin/customers/${c.id}`
                              : `/staff/customers/${c.id}`,
                          )
                        }
                        className="px-5 py-1.5 bg-indigo-600 text-white rounded-lg text-[10px] font-black hover:bg-indigo-700 shadow-sm"
                      >
                        VIEW
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
};


const Card = ({ title, value, color = "bg-gray-900", isCount = false }) => (
  <div
    className={`p-4 md:p-5 rounded-2xl border border-gray-800 shadow-md ${color}`}
  >
    <p className="text-[9px] md:text-[10px] font-bold text-gray-300 uppercase tracking-widest truncate">
      {title}
    </p>

    <p className="text-lg md:text-2xl font-extrabold mt-1 md:mt-2 text-white">
      {isCount ? value : `₹${Number(value).toLocaleString("en-IN")}`}
    </p>
  </div>
);

export default List;